import i18next from 'i18next';

i18next.addResources('es_CL', 'PeyaStatus', {
  rejected: 'Rechazado',
  expired: 'Caducado',
  preorder: 'Pre Order',
  confirmed: 'Confirmado',
  cancelled: 'Cancelado',
  inProgress: 'En proceso',
  nearPickup: 'Cerca de recoger',
  pickedUp: 'Recogido',
  nearDropOf: 'Cerca de entregar',
  completed: 'Completado'
});

i18next.addResources('es_CR', 'PeyaStatus', {
  rejected: 'Rechazado',
  expired: 'Caducado',
  preorder: 'Pre Order',
  confirmed: 'Confirmado',
  cancelled: 'Cancelado',
  inProgress: 'En proceso',
  nearPickup: 'Cerca de recoger',
  pickedUp: 'Recogido',
  nearDropOf: 'Cerca de entregar',
  completed: 'Completado'
});
